export default __webpack_public_path__ + "static/media/H1008.263df776.mp3";